var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pivotData.length > 0)?_c('div',[_c('vue-pivottable-ui',{attrs:{"data":_vm.pivotData,"aggregatorName":"Sum","rendererName":"Table Heatmap","rows":_vm.rows,"cols":_vm.cols,"vals":_vm.vals}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }